const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',

  CATEGORIES_LIST:'CATEGORIES_LIST',
  CATEGORIES_LIST_RESULT:'CATEGORIES_LIST_RESULT',
  CATEGORIES_FETCH_ID:'CATEGORIES_FETCH_ID',
  CATEGORIES_FETCH_LIST_ID:'CATEGORIES_FETCH_LIST_ID',




  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  CategoriesRead:(info)=>({
      type: actions.CATEGORIES_LIST,
      payload:{info,page:1}
  }),
  onPageChange: (info, page) => ({
    type: actions.CATEGORIES_LIST,
    payload: { info, page }
  }),
  categoriesListSuccess: (exportresult,result,success,total_count,labelfilter,grpfilter,page) => ({
   type: actions.CATEGORIES_LIST_RESULT,
   exportresult,
   result,
   success,
   total_count,
   labelfilter,
   grpfilter,
   page
 }),
 categoriesfetchBYId:(listid)=>({
   type: actions.CATEGORIES_FETCH_ID,
   payload:{listid}
 }),
 categoriesListById: (result,success) => ({
  type: actions.CATEGORIES_FETCH_LIST_ID,
  result,
  success
}),
};
export default actions;
